import type {CurrentPageContentPathFields} from "@khan/analytics-learning-time";
import {RequestInfo} from "@khan/shared-core";

import type {ResolvedContentPath} from "#content-library/types/types.ts";

// sync-start:map-cedar-content-path-fields 1492982856 ./apps/khanacademy/src/content-library/analytics-adapter.ts
// sync-start:map-cedar-content-path-fields 1377958103 ./apps/khanacademy/src/discussion-package/util/content-path-converter.ts

function deriveCurrentPageContentPathContentKind(
    contentPath?: ResolvedContentPath | null,
): CurrentPageContentPathFields["currentPageContentPath_contentKind"] {
    const kind = contentPath?.learnableNodeKind;
    if (kind != null && kind !== "") {
        return kind;
    }

    if (!contentPath?.courseId) {
        return "Domain";
    }
    if (!contentPath?.unitId) {
        return "Course";
    }
    if (!contentPath?.lessonId) {
        return "Unit";
    }

    return "Lesson";
}

/**
 * A helper function that returns the currentPageContentPath_ fields used in analytics events.
 *
 * @param contentPath An object representing the path of the currently visible
 * content.
 * @returns An object containing the currentPageContentPath_ fields.
 */
export function getCurrentPageContentPathFields(
    contentPath?: ResolvedContentPath | null,
): CurrentPageContentPathFields {
    return {
        currentPageContentPath_kaLocale: RequestInfo.kaLocale,
        currentPageContentPath_contentKind:
            deriveCurrentPageContentPathContentKind(contentPath),
        currentPageContentPath_contentId: contentPath?.learnableNodeId ?? null,
        currentPageContentPath_courseId: contentPath?.courseId ?? null,
        currentPageContentPath_unitId: contentPath?.unitId ?? null,
        currentPageContentPath_lessonId: contentPath?.lessonId ?? null,
        currentPageContentPath_domainId: contentPath?.domainId ?? null,
    };
}

// sync-end:map-cedar-content-path-fields
